import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/drivers`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, driverId) {
      const response = await axios.get(`${API_URL}/drivers/${driverId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, driver) {
      const response = await axios.post(`${API_URL}/drivers`, driver);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { driverId, driverData }) {
      const response = await axios.put(`${API_URL}/drivers/${driverId}`, driverData);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, driverId) {
      const response = await axios.delete(`${API_URL}/drivers/${driverId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getOptions(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/drivers/options`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};
